import { render, staticRenderFns } from "./PcInPlaceEditor.vue?vue&type=template&id=6392ae20"
import script from "./PcInPlaceEditor.vue?vue&type=script&lang=js"
export * from "./PcInPlaceEditor.vue?vue&type=script&lang=js"
import style0 from "./PcInPlaceEditor.vue?vue&type=style&index=0&id=6392ae20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
